import { useCallback } from 'react';
export const usePropertyName = () => {
  const appendPropertyNameUrlParam = useCallback((url, lodgingCard) => {
    var _a;
    const [path, search] = url.split('?');
    const urlSearchParams = new URLSearchParams(search);
    if (lodgingCard.__typename !== 'GenericDiscoveryCard') {
      const propertyName = (_a = lodgingCard.headingSection) === null || _a === void 0 ? void 0 : _a.heading;
      if (propertyName) urlSearchParams.append('propertyName', propertyName);
    }
    return `${path}?${urlSearchParams.toString()}`;
  }, []);
  return {
    appendPropertyNameUrlParam
  };
};